// @vue/component
export default {
  props: {
  },
  components: {
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    onMobileMenuClicked() {
      this.isOpen = !this.isOpen;
    },
  },
  computed: {
  },
};
